import React, { useCallback, useMemo } from 'react';
import AsyncSelect from 'react-select/async';

import { ReactComponent as CrossIcon } from '../../../assets/images/cross-outlined.svg';

import styles from './CustomMultiAsyncSelect.module.scss';

const CustomMultiAsyncSelect = ({
  formatOptionLabel,
  placeholder,
  isClearable,
  onChange,
  value,
  disabled,
  error,
  defaultOptions,
  backspaceRemovesValue,
  closeMenuOnSelect,
  hideSelectedOptions,
  loadOptions,
  getOptionValue = () => {},
  getOptionLabel = () => {},
  children,
}) => {
  const customStyles = useMemo(
    () => ({
      control: (base) => ({
        ...base,
        '&:hover': { borderColor: error ? '#EA5506' : '#BFBFBF' },
        border: error ? '1px solid #EA5506' : '1px solid #BFBFBF',
        boxShadow: 'none',
        display: 'flex',
        flexDirection: 'row-reverse',
      }),
      multiValue: (base) => ({
        ...base,
        border: '1px solid #0FBC71',
        borderRadius: '200px',
        backgroundColor: 'rgba(15, 188, 113, 0.05)',
        color: '#0FBC71',
        padding: '6px 10px',
        fontSize: '12px',
      }),
      multiValueLabel: (base) => ({
        ...base,
        color: '#0FBC71',
      }),
      option: (base) => ({
        ...base,
        color: '#343741',
        fontSize: '14px',
      }),
      placeholder: (defaultStyles) => ({
        ...defaultStyles,
        color: '#959595',
        fontSize: '14px',
      }),
      input: (base) => ({
        ...base,
        color: '#444444',
        fontSize: '14px',
      }),
      loadingIndicator: (base) => ({
        ...base,
        display: 'none',
      }),
    }),
    [error]
  );

  const handleRemove = useCallback(
    (toRemove) => {
      const filteredValue = value.filter((val) => val.value !== toRemove);
      onChange(filteredValue);
    },
    [value]
  );

  return (
    <div>
      <AsyncSelect
        defaultOptions={defaultOptions}
        components={{
          DropdownIndicator: () => null,
          IndicatorSeparator: () => null,
          ClearIndicator: () => null,
          loadingIndicator: () => null,
        }}
        styles={customStyles}
        onChange={onChange}
        backspaceRemovesValue={backspaceRemovesValue}
        closeMenuOnSelect={closeMenuOnSelect}
        hideSelectedOptions={hideSelectedOptions}
        isMulti
        formatOptionLabel={formatOptionLabel}
        placeholder={placeholder}
        isClearable={isClearable}
        value={value}
        isDisabled={disabled}
        controlShouldRenderValue={false}
        getOptionLabel={getOptionLabel}
        getOptionValue={getOptionValue}
        loadOptions={loadOptions}
      />
      {children ??
        (!!value?.length && (
          <div className={styles.selectedOptionsCont}>
            {value.map((option) => (
              <div className={styles.selectedOption} key={option.value}>
                <p className={styles.selectedLabel}>{option.label}</p>
                <CrossIcon className={styles.removeIcon} onClick={() => handleRemove(option.value)} />
              </div>
            ))}
          </div>
        ))}
    </div>
  );
};

export default CustomMultiAsyncSelect;
